<script>
export default {
  props: ['formdata'],
  data() {
    return {
      localModel: {},
      initial:true,
    }
  },
  methods: {
    nextStep() {
      this.initial = false
      if (this.validate()) {
        this.emitter.emit("modelUpdated", this.localModel);
        this.emitter.emit("step", 2);
      }
    },
    validate() {

      if (this.localModel.firstname === "" ||
          this.localModel.lastname === "" ||
          this.localModel.phone === ""
      )
        return false;

      if (!this.validateEmail(this.localModel.email)) {
        return false;
      }
      return true;
    },
    validateEmail(mail) {
      if (mail !== null && mail !== undefined) {
        var validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return (mail.match(validRegex) !== null)
      }
      return false;
    }
  },
  mounted() {
    this.localModel = this.formdata;
  }
}
</script>

<template>

  <!------------ step form Area Start  ----------->
  <section class="step-form" v-if="localModel !== {}">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="step-form-wrapper">
            <div class="contact-form">
              <form action="">
                <div class="step-form-content">
                  <form action="data.php" method="post" class="form">
                    <!-- Progress Bar -->
                    <div class="progress-bar">
                      <div class="progress" id="progress"></div>
                      <div class="progress-step active" data-title="Personal"></div>
                      <div class="progress-step" data-title="Contact "></div>
                      <div class="progress-step" data-title="Experiences"></div>
                      <div class="progress-step" data-title="Links"></div>
                    </div>

                    <!-- Steps -->
                    <div class="form-step active">
                      <h3>Persoonlijke gegevens</h3>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Voornaam*</label>
                                <input type="text" v-model="localModel.firstname"
                                       :class="localModel.firstname === '' && initial === false ? 'invalid' : ''"
                                       placeholder="Voornaam">
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Achternaam*</label>
                                <input type="text" v-model="localModel.lastname"
                                       :class="localModel.lastname === '' && initial === false ? 'invalid' : ''"
                                       placeholder="Achternaam">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="contact-form-info">
                                <label for="">E-mailadres*</label>
                                <input type="text" v-model="localModel.email"
                                       :class="!validateEmail(localModel.email) && initial === false ? 'invalid' : ''"
                                       placeholder="E-mailadres">
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Telefoon*</label>
                                <input type="text" v-model="localModel.phone"
                                       :class="localModel.phone === '' && initial === false ? 'invalid' : ''"
                                       placeholder="Telefoon">
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="contact-form-info">
                                <label for="">Mobiel</label>
                                <input type="text" v-model="localModel.cellphone" placeholder="Mobiel">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="contact-form-btn">
                  <button @click.prevent="nextStep">Volgende</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!------------ step form Area End ------------->


</template>

<style scoped>

</style>